module.exports = __webpack_public_path__ + "img/autosense-product-page-2x.9b4000c1.png";